export default __webpack_public_path__ + "static/media/1177.d30ae9a2.png";